module.exports = __webpack_public_path__ + "img/location-icon.5bb26940.svg";